import { Button } from 'react-bootstrap';
import styled from 'styled-components';

export const CommentReplyButtonContainer = styled(Button)`
  font-size: 10px;
  border-radius: 6px;
`;

export const DropdownMenu = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  min-width: 160px;
  padding: 5px 0;
  margin: 2px 0 0;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
`;

export const DropdownItem = styled.div`
  padding: 8px 20px;
  clear: both;
  font-weight: 400;
  line-height: 1.42857143;
  color: #333;
  white-space: nowrap;
  cursor: pointer;
  font-size: 12px;

  &:hover {
    background-color: #f5f5f5;
  }
`;
